const state = {
  active: false,
  url: ''
}

export default state